export const NOTCH_SPREAD = 54;
export const NOTCH_DEPTH = 34;
export const NOTCH_SMOOTH = 0.62;
